import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as epic from '../epic'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: epic.RESOURCE.payload.dimension.partialId,
      partialId: epic.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The Jira epic status.',
    isOptional: true,
    name: 'Jira Status',
    partialId: PartialId.Standard.create('jira_status'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.jiraStatus.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
